"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Upgrade/UpgradeModal/components/SmsAddonCard.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _cost = require('shared/services/cost');
var _upgradePlans = require('shared/constants/upgradePlans');
var _Form = require('web/components/Form');
var _TierSelector = require('../SMSPlanModal/TierSelector'); var _TierSelector2 = _interopRequireDefault(_TierSelector);
var _PlanCardTitle = require('./PlanCardTitle'); var _PlanCardTitle2 = _interopRequireDefault(_PlanCardTitle);











const SmsAddonCard = ({
  orgName,
  isSelected,
  onToggle,
  smsItem,
  smsItemsList,
  smsItemMinCost,
  onTierChange,
}) => {
  const baseCost = (_optionalChain([smsItem, 'optionalAccess', _ => _.BaseCost]) || 0) 
  const pricePerContact = smsItem
    ? _cost.formatDisplayUnitCost.call(void 0, baseCost, smsItem.Units)
    : null

  return (
    _react2.default.createElement('div', { className: "plan-modal--summary--addon-card", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
      , _react2.default.createElement('div', { className: "plan-modal--summary--addon-card--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
        , _react2.default.createElement('img', {
          className: "plan-modal--summary--info--icon",
          src: _upgradePlans.SMSMessagingPlan.iconSrc, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
        )
        , _react2.default.createElement('div', { className: "plan-modal--summary--info--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
          , _react2.default.createElement(_PlanCardTitle2.default, { planName: _upgradePlans.SMSMessagingPlan.name, orgName: orgName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}} )
          , _react2.default.createElement('span', { className: "plan-modal--summary--info--desc-price", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
            ,  isSelected && pricePerContact
              ? `${pricePerContact} per contact`
              : `Optional add-on, starting at ${_cost.formatDisplayCost.call(void 0, smsItemMinCost)} per month`
            
          )
        )
        , _react2.default.createElement(_Form.Toggle, {
          className: "plan-modal--summary--addon-card--toggle",
          isChecked: isSelected,
          onChange: onToggle,
          ariaLabel: _upgradePlans.SMSMessagingPlan.name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
        )
      )
      ,  isSelected && smsItem && (
        _react2.default.createElement('div', { className: "plan-modal--summary--addon-card--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
          , _react2.default.createElement(_TierSelector2.default, {
            selectedItem: smsItem,
            smsItemsList: smsItemsList,
            onChange: onTierChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
          )
          , _react2.default.createElement('div', { className: "plan-modal--summary--info--price", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
            , _react2.default.createElement('span', { className: "plan-modal--summary--info--price-tag", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}
              ,  _cost.formatDisplayCost.call(void 0, baseCost) 
            )
            , _react2.default.createElement('span', { className: "plan-modal--summary--info--price-freq", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}, "billed monthly"

            )
          )
        )
      )
    )
  )
}

exports. default = SmsAddonCard
